import { ArrowRight } from "lucide-react";
import { useLocation } from "react-router-dom";
import { isPrivatePath, legacyAppPath } from "@/const/appRoutes";
import { useLang } from "@/contexts/LangContext";

export default function NotFoundScreen() {
  const { t } = useLang();
  return (
    <div className="screen-container not-found-screen" data-testid="not-found-screen">
      <div className="not-found-stage">
        <p className="not-found-code" aria-hidden="true">{t("not_found_code")}</p>
        <div className="not-found-break" aria-hidden="true">
          <span />
          <i />
          <span />
        </div>
        <h1 className="not-found-title">{t("not_found_title")}</h1>
        <p className="not-found-text">{t("not_found_body")}</p>
        <a className="btn-primary not-found-home" href="/">
          <span>{t("not_found_home")}</span>
          <ArrowRight size={16} aria-hidden="true" />
        </a>
      </div>
    </div>
  );
}

/** Paths where App.js is about to replace the URL for the other auth state — stay blank, not 404. */
function isAuthHandoffPath(pathname) {
  return pathname === "/"
    || pathname === "/landing"
    || pathname.startsWith("/ref_");
}

function isGuestHandoffPath(pathname) {
  return pathname === "/landing"
    || isPrivatePath(pathname)
    || legacyAppPath(pathname)
    || pathname.startsWith("/ref_");
}

export function GuestUnknownRoute() {
  const { pathname } = useLocation();
  if (isGuestHandoffPath(pathname)) return null;
  return <NotFoundScreen />;
}

export function AuthorizedUnknownRoute() {
  const { pathname } = useLocation();
  if (isAuthHandoffPath(pathname) || legacyAppPath(pathname)) return null;
  return <NotFoundScreen />;
}
